import { LicenseService } from '@services/LicenseService';
import { ViewType } from 'react-big-scheduler-stch';
import dayjs from 'dayjs';

export const QUERY = {
  ADELANTO_VACACIONAL: 'adelantoVacacional',
  CURRENT_USER: 'currentUser',
  STATUS: 'status_control',
  STATIC_CONTENT: 'staticContent',
  INSTITUTIONALS: 'institutionals',
  LICENSES: 'licenses',
  LICENSES_BOSS: 'licensesBoss',
  TAREAS_PENDIENTES: 'tareasPendientes',
  TUTORIALS: 'tutorials',
  HOME: 'home',
  SHORCUTS: 'shorcuts',
  GANTT: 'gantt',
  TU_ARSAT: 'tuArsat',
  BIRTHDAY: 'birthday',
  NOTA: 'nota',
  NOTIFICATION_PREFERENCES: 'notificationPreferences',
  PAGINA: 'pagina',
  TOPICS: 'topics',
  SEARCH: 'search',
  SUGGESTED_SEARCHES: 'suggestedSearches',
  CHECK_STATUS: 'checkStatus',
  SEARCH_MORE_INFO: 'moreInfo',
  INFORMACION_Y_RECURSOS: 'informacionyRecursos',
  USE_AUTOCOMPLETE_SUBGERENCIAS: 'use_autocomplete_subgerencias',
  USE_BOSS_WARNINGS: 'use_boss_warnings',
  USE_WORKPLACE_OPTION: 'use_workplace_option',
  HOLIDAYS: 'holidays',
  AUTOCOMPLETE_TAGS_EMPLOYEES: 'autocomplete_tags_employees',
  ROLES: 'roles',
  SOLICITUD_GUARDERIA: 'solicitud_guarderia',
};

export const VACATION_ADVANCE_PAYMENT_MESSAGES = {
  enabled: {
    true: {
      main: 'Recibirás el adelanto vacacional. Se acreditará al iniciar la licencia y se descontará al final del mes.',
      secondary:
        'Se aplicará para todas las vacaciones que goces dentro de los meses afectados.',
    },
    false: {
      main: 'No recibirás el adelanto vacacional.',
      secondary:
        'Se aplicará para todas las vacaciones que goces dentro de los meses afectados.',
    },
  },
  disabled: {
    true: {
      main: 'Todas las vacaciones del mismo período deben regirse por el mismo criterio. Como ya presentaste una solicitud anterior, recibirás el adelanto vacacional correspondiente a los días que estás solicitando ahora.',
    },
    false: {
      main: 'Todas las vacaciones del mismo período deben regirse por el mismo criterio. Como ya presentaste una solicitud anterior, no recibirás el adelanto correspondiente a los días que estás solicitando ahora.',
    },
  },
};

export const ERROR_CODES = {
  TOKEN_EXPIRED: 'token-expired',
  TOKEN_INVALID: 'token-invalid',
  NETWORK_ERROR: 'network-error',
  LOGOUT: 'logout',
  COMMUNICATION_NOT_FOUND: 'contenido-inexistente',
  USER_SHARED_NOT_VALID: 'usuario-compartido-no-valido',
};

export const Roles = { TESTER: 'tester' };

export const AUTH_MODE = {
  LDAP: 'ldap',
  INTERNAL: 'internal',
};

export const ROWS_PER_PAGE = [10, 20, 100, 500, 1_000, 2_000];
export const ROWS_PER_PAGE_SMALL = [5, 10, 20, 100, 500];

const LOGIN_ERRORS = {
  'login-user-not-exists':
    'El usuario no está vinculado correctamente, comuníquese con soporte.',
  'login-wrong-password': 'Contraseña incorrecta',
  'login-email-not-confirmed':
    'Para completar el registro es necesario que nos confirmes tu correo electrónico.',
  'login-expired-token': 'Expiró el token. Cerrá la sesión y volvé a ingresar.',
  'login-bad-token':
    'Error con el token. Si persiste cerrá la sesión y volvé a ingresar.',
  'login-wrong-user-or-password': 'El usuario o la contraseña son incorrectos.',
  'login-error': 'Error de ldap. Informalo a soporte (soporte@arsat.com.ar)',
  'login-user-not-in-db':
    'El usuario no está en Ceres. Informalo a RRHH para resolver la situación.',
};

export const ERRORS_FILES = {
  'not-enough-permissions': 'No tenés permisos para realizar esta acción',
};

export const ERROR_TAGS_EMPLOYES = {
  'etiqueta-already-exists': 'La etiqueta ya existe',
  'etiqueta-no-disponible':
    'Las etiquetas "all" y "todos" son de uso reservado por el sistema',
};

export const COMMON_MESSAGES = {
  error: 'Ocurrió un error',
  success: 'Guardado con éxito',
};

export const WARNINGS = {
  'consecutive-medical-license':
    'La fecha seleccionada es contigua con otra licencia por enfermedad. Si se trata de la misma licencia podés extender la original. ',
  'coincident-medical-license':
    'La fecha seleccionada se superpone con otra licencia por enfermedad. Si se trata de la misma licencia podés extender la original sino modificá la fecha para generar una nueva.',
  'not-multiple-of-7':
    'La cantidad de días solicitados o el saldo de días restantes deberían ser múltiplos de 7.',
  'not-enough-days':
    'La cantidad de días solicitados supera los días disponibles. Por favor, contactate con Recursos Humanos',
  'not-monday': 'El día de inicio de vacaciones no es lunes',
  'coincident-license':
    'Las fechas solicitadas coinciden con otra licencia aprobada o en proceso.',
  'consecutive-vacation-license':
    'No puede ser consecutivo al período de vacaciones.',
  'consecutive-procedure-license':
    'La fecha solicitada es consecutiva o inmediatamente anterior a un día de licencias por motivos personales.',
  'not-working-day': 'El día solicitado es feriado o fin de semana.',
  'from-date-not-working-day': 'El día de inicio es feriado o fin de semana',
  'not-ongoing-studies': 'No se registran estudios en curso.',
  'not-working-day-rotativo':
    'El día solicitado es feriado o fin de semana, pero registra turnos rotativos.',
  'not-monday-rotativo':
    'El día de inicio de vacaciones no es lunes, pero registra turnos rotativos.',
  'from-date-not-working-day-rotativo':
    'El día de inicio es feriado o fin de semana, pero registra turnos rotativos.',
  'supervisor-dado-baja':
    'El superior inmediato del solicitante se encuentra dado de baja',
  fecha_solicitada_pasada: ' La fecha solicitada se encuentra en el pasado.',
  distancia_menor_200:
    'La distancia es menor a los 200km del lugar de trabajo.',
  licencia_coincidente:
    'La fecha solicitada coincide con una licencia programada.',
  ticket_duplicado: (data: { numero_ticket: any; nro_viaje: any }) =>
    `La OT-${data?.numero_ticket} tambien se encuentra en el viatico #${data?.nro_viaje}.`,
};

export const ICONS = {
  vacation: 'Sunglasses',
  vacaciones: 'Sunglasses',
  exam: 'GraduationCap',
  examen: 'GraduationCap',
  procedure: 'PersonSimpleRun',
  tramite: 'PersonSimpleRun',
  tramite_morning: 'PersonSimpleRun',
  procedure_morning: 'PersonSimpleRun',
  tramite_afternoon: 'PersonSimpleRun',
  procedure_afternoon: 'PersonSimpleRun',
  procedure_full_day: 'PersonSimpleRun',
  enfermedad: 'Pill',
  medical: 'Pill',
  enfermedad_familiar: 'UsersFour',
  ART: 'FirstAid',
  art: 'FirstAid',
  donacion_de_sangre: 'Drop',
  donacion_sangre: 'Drop',
  mudanza: 'Package',
  matrimonio: 'Heart',
  maternidad: 'Baby',
  paternidad: 'Baby',
  excedencia: 'Baby',
  sin_goce_de_sueldo: 'BagSimpleCross',
  citacion_judicial: 'Scales',
  fallecimiento_familiar: 'HandHeart',
  bomberos_voluntarios: 'FireExtinguisher',
  deportiva: 'PersonSimpleBike',
  gremial: 'MegaphoneSimple',
  religiosa: 'HandsPraying',
};

export const LICENSE_PRESENTEEISM_TEXT = {
  vacation: 'Vacaciones',
  exam: 'Día de Examen',
  procedure: 'Motivos Personales',
  enfermedad: 'Enfermedad',
  medical: 'Enfermedad',
  enfermedad_familiar: 'Enfermedad Familiar',
  ART: 'ART',
  art: 'ART',
  donacion_de_sangre: 'Día de Donación de Sangre',
  donacion_sangre: 'Día de Donación de Sangre',
  mudanza: 'Día de Mudanza',
  matrimonio: 'Matrimonio',
  maternidad: 'Maternidad',
  paternidad: 'Paternidad',
  excedencia: 'Excedencia',
  sin_goce_de_sueldo: 'Sin Goce de Sueldo',
  citacion_judicial: 'Citación Judicial',
  fallecimiento_familiar: 'Fallecimiento Familiar',
  bomberos_voluntarios: 'Bomberos Voluntarios',
  deportiva: 'Deportiva',
  gremial: 'Gremial',
  religiosa: 'Religiosa',
  permiso_medico_maniana: 'Permiso Médico (mañana)',
  permiso_medico_tarde: 'Permiso Médico (tarde)',
  tramite_maniana: 'Motivos Personales (mañana)',
  procedure_morning: 'Motivos Personales (mañana)',
  tramite_tarde: 'Motivos Personales (tarde)',
  procedure_afternoon: 'Motivos Personales (tarde)',
  procedure_full_day: 'Motivos Personales',
};

export const TREE_STATUS_WHITH_NAME = [
  'authorized',
  'confirmed',
  'cancelled',
  'not-objected',
];

export const TREE_STATUS_WHITH_NAME_MEDICAL = [
  ...TREE_STATUS_WHITH_NAME,
  'file-uploaded',
  'modified',
  'justified',
  'objected',
];

export const CARD_COLOR = {
  approved: '#2E7D32',
  rrhh_approved: '#2E7D32',
  justified: '#2E7D32',
  in_process: '#50B8B1',
  hr_pending: '#50B8B1',
  rejected: '#D32F2F',
  to_be_discounted: '#D32F2F',
  not_justified: '#D32F2F',
  document_pending: '#ED6C02',
  document_loaded: '#ED6C02',
  interrupted: '#535554',
  cancelled: '#535554',
  objected: '#535554',
  extension_en_evaluacion: '#ED6C02',
  registrada: '#50B8B1',
  aprobada: '#2E7D32',
  en_rrhh: '#2E7D32',
  rechazada: '#D32F2F',
  anulada: '#D32F2F',
  cancelada: '#535554',
  activa: '#2E7D32',
  en_proceso: '#50B8B1',
  rechazado: '#D32F2F',
  en_gerencia: '#50B8B1',
  en_gaf: '#ED6C02',
  aprobado_para_viajar: '#2E7D32',
  confirmado: '#2E7D32',
  suspendido: '#23362dff',
  rectificado: '#50B8B1',
  rectificacion_a_liquidar: '#50B8B1',
  rectificacion_liquidada: '#2E7D32',
  rectificacion_rechazada: '#D32F2F',
  confirmacion_pendiente: '#ED6C02',
  suspension_a_liquidar: '#50B8B1',
  suspension_liquidada: '#2E7D32',
  cancelado: '#535554',
  synchronized: '#2E7D32',
};

export const CARD_DETAIL_COLOR = {
  approved: '#D2E9D4',
  in_process: '#C7DCDA',
  hr_pending: '#D6F0F1',
  rejected: '#FFD2D2',
  interrupted: '#D4D5D5',
  cancelled: '#D4D5D5',
  document_pending: '#FFEEE1',
  document_loaded: '#FFEEE1',
  to_be_discounted: '#FFD2D2',
  not_justified: '#FFD2D2',
  rrhh_approved: '#D2E9D4',
  justified: '#D2E9D4',
  extension_en_evaluacion: '#FFEEE1',
  objected: '#D4D5D5',
  registrada: '#C7DCDA',
  aprobada: '#D2E9D4',
  en_rrhh: '#D6F0F1',
  rechazada: '#FFD2D2',
  anulada: '#FFD2D2',
  cancelada: '#D4D5D5',
  activa: '#D2E9D4',
  rectificacion_rechazada: '#FFD2D2',
  en_proceso: '#D4E9E7',
  confirmacion_pendiente: '#FFEEE1',
  synchronized: '#D2E9D4',
};

export const DATE_FORMAT = {
  STANDARD: 'DD/MM/YYYY',
  STANDARD_LIGHT: 'DD/MM/YY',
  STANDARD_LIGHT_WITH_DAY_OF_WEEK: 'dddd DD/MM/YY',
  STANDARD_WITHOUT_YEAR: 'DD/MM',
  STANDARD_TIME: 'DD/MM/YYYY - HH:mm',
  STANDARD_TIME_WITHOUT_YEAR: 'DD/MM - HH:mm',
  STANDARD_TIME_WITH_DAY: 'dddd DD/MM/YYYY - HH:mm',
  READABLE_TIME: 'DD/MM/YYYY HH:mm',
  READABLE_DAY: 'DD/MM dddd',
  READABLE_DAY_WITH_READABLE_MONTH: 'dddd DD MMMM',
  READABLE_DAY_FIRST: 'dddd DD/MM',
  READABLE_MONTH: 'DD MMMM YYYY',
  READABLE_MONTH_WITH_YEAR: 'MMMM YYYY',
  TIME: 'HH:mm',
  TIME_WITH_DOTS: 'H.mm',
  MONTH: 'mm',
  YEAR: 'YYYY',
  HISTORY: 'D MMM YYYY',
  SCHEDULER: 'YYYY-MM-DD HH:mm:ss',
  UTC_DATE: 'YYYY-MM-DD',
  UTC_TIME: 'HH:mm:ss',
};

export const COMUNICADOS = {
  NOTA: 'nota',
  PAGINA: 'pagina',
};

export const allItemsFilter = {
  label: 'Todos',
  value: 'all',
};

export const EMAILS = {
  tecnical: 'soporte@arsat.com.ar',
  cybersecurity: 'ciberseguridad@arsat.com.ar',
  suggestions: 'portaldeempleados@arsat.com.ar',
};

export const AVATAR_TYPE = {
  DEFAULT: 'default',
  PHONE: 'phone',
};

export const Z_INDEX = {
  MINIMUM: 0,
  LOWER: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const DROPZONE_MODAL_TYPE = {
  DOCUMENTS: 'documents',
  CERTIFICATE: 'certificate',
  MEDICAL_EXTENSION: 'medicalExtension',
  SEND_MESSAGE: 'sendMessage',
};

export const DROPZONE_MODAL_UPLOADS = {
  documents: LicenseService.uploadDocuments,
  certificate: LicenseService.uploadCertificate,
  medicalExtension: LicenseService.uploadMedicalExtension,
  sendMessage: LicenseService.uploadAndSendMessage,
};

export const schedulerInitialValues = {
  nonAgendaOtherCellHeaderFormat: 'DD',
  tableHeaderHeight: '40px',
  schedulerMaxHeight: '50px',
  weekCellWidth: '11%',
  monthCellWidth: '2.5%',
  views: [
    {
      viewName: 'Semana',
      viewType: ViewType.Week,
      showAgenda: false,
      isEventPerspective: false,
    },
    {
      viewName: 'Mes',
      viewType: ViewType.Month,
      showAgenda: false,
      isEventPerspective: false,
    },
    {
      viewName: 'Año',
      viewType: ViewType.Year,
      showAgenda: false,
      isEventPerspective: false,
    },
  ],
  resourceName: '',
  schedulerContentHeight: '100%',
  weekEndColorCell: '#f1f1f1',
  isTodayColorCell: '#E0F1FF',
  dragAndDropEnabled: false,
  checkConflict: true,
  besidesWidth: 0,
  monthResourceTableWidth: '20%',
  weekResourceTableWidth: '20%',
  schedulerWidth: '100%',
  nonAgendaSlotMinHeight: 45,
  yearCellWidth: 20,
  yearResourceTableWidth: '20%',
  defaultExpanded: false,
  headerEnabled: false,
  widthBalanceButton: 100,
};

export const staticDatePickerData = {
  views: { 2: ['year', 'month'], 1: ['year', 'month', 'day'], 4: ['year'] },
  minDate: dayjs('2023-07'),
  maxDate: dayjs('2040-01'),
};

export const slotItemContainerDiv = 'SlotItemContainer-';
export const tdSchedulerUserHeaders = 'td-scheduler-user-headers';
export const keyAutocompleteTagList = 'etiquetas_list';

export const COMPARTIDOS = {
  POR_MI: 'forMy',
  CONMIGO: 'withMe',
};

export const SHARED_PERMISOS = {
  LECTOR: 'lector',
  EDITOR: 'editor',
  BORRAR_PERMISOS: 'delete',
};

export const SHARED_PERMISOS_TYPES = [
  SHARED_PERMISOS.LECTOR,
  SHARED_PERMISOS.EDITOR,
];

export const ERRORS_USE_UPLOAD_FILE = {
  'file-too-large':
    'El archivo supera el tamaño maximo de megabytes permitidos',
};

export const ERRORS_COMMONS = {
  default: 'Hubo un error',
  'password-incorrecto': 'Password Incorrecto',
  'clave-incorrecta': 'Clave incorrecta',
};

export const ERRORS_DATEPICKER = {
  INVALID_RANGE:
    '* La fecha "Desde" debe ser menor o igual a la fecha "Hasta" ',
  NOT_VALID_DATE: '* La fecha no es valida, debe tener el formato DD/MM/YYY',
};

export const HEADER = {
  PRESENTISMO: { id: 'presentismo', order: 0 },
  ENCUESTA: { id: 'encuesta_vista_previa', order: 1 },
  COMUNICADO: { id: 'comunicado_vista_previa', order: 2 },
  PREVIEW: { id: 'preview_text', order: 3 },
};

export const TYPE_OF_SHARED = {
  IRREGULARITY: 'presentismo',
  LICENSE: 'licencias',
  VIATICOS: 'viaticos',
};

export const TRANSLATION_ERRORS = {
  'no-eliminado-nota-publicada':
    'No se pueden eliminar notas publicadas. Se debe despublicar para eliminarla.',
  'no-editado-nota-publicada':
    'No se pueden editar notas publicadas. Se debe despublicar para editarla.',
  'no-eliminado-comunicado-publicado':
    'No se pueden eliminar comunicados publicados. Se debe despublicar para eliminarlo.',
  'no-editado-comunicado-publicado':
    'No se pueden editar comunicados publicados. Se debe despublicar para editarlo.',
  'no-eliminado-pagina-publicada':
    'No se pueden eliminar páginas publicadas. Se debe despublicar para eliminarla.',
  'no-editado-pagina-publicada':
    'No se pueden editar páginas publicadas. Se debe despublicar para eliminarla.',
  'user-not-exists': 'El usuario asocioado con esta acción no existe',
  'id-invalido': 'El Id de archivo es inválido',
  'file-type-not-supported': 'El formato del archivo es inválido.',
  'not-enough-permissions': 'No tiene permisos para realizar esta acción',
  'file-size-too-large': 'El archivo supera el tamaño máximo permitido',
  'archivo-inexistente': 'El archivo no existe',
  'comunicado-inexistente': 'El comunicado no existe',
  'pagina-inexistente': 'La página no existe',
  'nota-inexistente': 'La nota no existe',
  'comunicado-sin-notificacion':
    'El comunicado no tiene activa la notificación.',
  'notificacion-ya-enviada': 'La notificación del comunicado ya fue enviada',
  offline: 'Es posible que sea tu conexión a internet. Volvé a intentar',
  'role-manager-conflict':
    'El administrador de roles no puede quitarse el rol a si mismo. Lo debe hacer otro administrador de roles',
  'posee-paginas-asociadas':
    'No se puede eliminar una página con páginas hijas. Para eliminarla reubicá las hijas debajo de otra página padre o eliminalas.',
  'usuario-no-designado': 'No tenés permisos para realizar esa acción',
  'fecha-fichada-no-valida': 'Fecha de fichada no válida',
  'no-existen-reportes-para-el-periodo': 'No existen reportes para el período',
  falta_filtro_usuario: 'Debe ingresar apellido, nombre o número de legajo',
};

export const COMMON_ERRORS: Record<string, string> = {
  ...ERROR_TAGS_EMPLOYES,
  ...ERRORS_FILES,
  ...COMMON_MESSAGES,
  ...LOGIN_ERRORS,
  ...ERRORS_COMMONS,
  ...TRANSLATION_ERRORS,
  'id-user-and-roles-required': 'El id y los roles son requeridos',
  'not-enough-permissions':
    'El usuario no está en el grupo de seguridad de administradores. Informalo a soporte (soporte@arsat.com.ar)',
  'connection-error':
    'Falló la conexión con ldap. Informalo a soporte (soporte@arsat.com.ar)',
  'user-token-failed':
    'Error en el armado del token. Informalo a soporte (soporte@arsat.com.ar)',
  dismissed:
    'El usuario fue dado de baja en Ceres. Informalo a RRHH para resolver la situación.',
  duplicated_id:
    'El id del usuario se encuentra duplicado en Ceres. Informalo a RRHH para resolver la situación.',
  duplicated_file_number:
    'El legajo del usuario se encuentra duplicado en Ceres. Informalo a RRHH para resolver la situación.',
  supervisor_loop:
    'El usuario figura como su propio superior en Ceres. Informalo a RRHH para resolver la situación.',
  supervisor_none:
    'El usuario no tiene superior en Ceres. Informalo a RRHH para resolver la situación.',
  supervisor_not_exists:
    'El superior del usuario no existe en Ceres. Informalo a RRHH para resolver la situación.',
  supervisor_dismissal:
    'El superior del usuario fue dado de baja en Ceres. Informalo a RRHH para resolver la situación.',
  'anio-no-corriente': 'Los días para el año próximo aún no están habilitados',
  'fecha-supera-maximo-pasado': 'La fecha no puede ser pasada.',
  'Not Found': 'No se encontró el recurso solicitado.',
  'user-not-enough-permissions': 'No tenés permisos para realizar esta acción.',
  'solicitud-not-exists': 'La pagina no existe',
  'hijo-mayor-que-7': 'El hijo seleccionado es mayor de 7 años',
};
